export const ORGANISATION_EMPLOYEE = { key: 'ORGANISATION_EMPLOYEE', name: 'Check-In' };
export const ORGANISATION_EDITOR = { key: 'ORGANISATION_EDITOR', name: 'Eventmanager' };
export const ORGANISATION_OWNER = { key: 'ORGANISATION_OWNER', name: 'Besitzer' };
